export default "__VITE_ASSET__bac2fdd8__"